import React from "react";

export function Divider() {
  return <div className="w-full h-px bg-menuBorder" aria-hidden="true" />;
}

export default Divider;
